export const curationAtlasNotesEntityTypes = [
  'LANDSCAPE_PAPER',
] as const;
